// extracted by mini-css-extract-plugin
export default {"sidenav":"Tutorial_sidenav__RjsJc","videoframe":"Tutorial_videoframe__D62TZ","color":"Tutorial_color__EfrOs"};